import React, { FC } from 'react';
import { Image } from 'antd';
import { useMediaQuery } from '@mui/material';
import { Banner, BannerImages } from '@monorepo/types';
import {
  ERROR_TYPES,
  UIErrorService,
} from '../../../../../../services/core/error-service';
import { useDashboard } from '../../../../contexts/hooks/use-dashboard';
import { usePromotionalBannersState } from '../hooks';

interface BannerItemProps {
  banner: Banner;
}

export const BannerItem: FC<BannerItemProps> = ({ banner }) => {
  const isMobile = useMediaQuery('(max-width: 899px)');
  const isTablet = useMediaQuery('(min-width: 900px) and (max-width: 1199px)');
  const isDesktop = useMediaQuery('(min-width: 1200px)');

  const { program } = useDashboard();

  const { handleBannerClick, isCartLoading } = usePromotionalBannersState({
    bannerName: banner.name,
    bannerId: banner.bannerId,
    link: banner.link,
    programId: program?._id,
  });

  const getBannerUrl = (images: BannerImages) => {
    if (isDesktop) {
      return images.desktopUrl;
    }

    if (isTablet && images.tabletUrl) {
      return images.tabletUrl;
    }
    if (isMobile && images.mobileUrl) {
      return images.mobileUrl;
    }

    return images.desktopUrl;
  };

  const bannerUrl = getBannerUrl(banner.images);

  if (!bannerUrl) {
    new UIErrorService({
      name: ERROR_TYPES.CLIENT,
      message: `Banner URL is not defined for banner: ${banner.name}`,
      data: {
        bannerName: banner.name,
        bannerId: banner.bannerId,
        bannerImages: banner.images,
      },
    });
    return null;
  }

  return (
    <button
      type="button"
      onClick={handleBannerClick}
      disabled={isCartLoading}
      style={{
        cursor: banner.link ? 'pointer' : 'default',
        border: 'none',
        padding: 0,
        background: 'none',
        width: '100%',
        display: 'block',
      }}
      aria-label={banner.name}
      data-is-checkout={banner.isCheckout}
      data-banner-id={banner.bannerId || banner.name}
    >
      <Image width="100%" src={bannerUrl} preview={false} alt={banner.name} />
    </button>
  );
};
